<script>
import StrapSearchResult from '@phoenix/mixins/components/strap-search/StrapSearchResult';

export default {
  mixins: [StrapSearchResult],

  async mounted() {
    this.STRAP_SEARCH_SET_BLOCK_FILTERS_ID(this.blockFiltersId);
    const reference = new URLSearchParams(window.location.search).get('reference') ?? null;

    if (reference) {
      this.STRAP_SEARCH_SET_WATCH_REF(reference);
      await this.getStrapFromWatchReference();
    }

    if (!this.watchReference || (this.watchReference && !this.hasResult)) {
      await this.getAllStraps();
    }
  },
};
</script>

<template>
  <div :class="{ 'mb-6': isLoading }">
    <div v-if="isLoading" class="simple-section simple-section--dark">
      <div class="loader"></div>
    </div>

    <mixed-grid
      v-if="(hasResult || hasAllStrapsResult) && !isLoading"
      data-cy="mixed-grid"
      :unique-id="uniqueId"
      :products="productsToDisplay.straps"
      :has-load-more="true"
      :filters="productsToDisplay.filters"
    >
      <div class="flex flex-grid--center items-center" style="height: 500px">
        <div class="loader loader--dark">
          <div class="loader__inner"></div>
        </div>
      </div>
    </mixed-grid>
  </div>
</template>
